import { requestWithToken as request } from "./api";
import { buildQuery } from "@/utils/queryString";

// URL de descarga vía el servicio Go. Vive en upload_files_view desde el
// retiro del flujo legacy de subida de archivos (general_file_upload).
export const getUrlsDownloadFile = (data = {}) =>
    request.post(
        `/upload_files_view/get_url_download_file/?format=json`,
        data
    );

// Fallback de descarga: el backend regenera el xlsx del mes desde la BD
// (o la plantilla vacía con template: 1) cuando el archivo de Drive no está
// disponible. Respuesta binaria → responseType blob.
export const downloadSpreadsheetMonthFile = (params = {}) =>
    request.get(
        `/upload_files_view/download_month_file/${buildQuery(params)}`,
        { responseType: "blob" }
    );

// El pase real responde 202 {status: "processing", run_id}: el import corre
// en RQ (cola imports) y se sondea con getUploadStatus. El dry_run sigue
// respondiendo el resumen de solapes en la misma llamada.
export const uploadFileExcel = (data = {}) =>
    request.post("/upload_files_view/upload_new_file/", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

// Estado de una subida mensual: {run_id, status (P/S/E), error, result
// (la planilla del mes, como la devolvía el POST sincrónico), progress}.
export const getUploadStatus = (runId) =>
    request.get(
        `/upload_files_view/upload_status/${buildQuery({ run_id: runId })}`
    );

export const getAllFilesUploadedByYear = (data = {}) =>
    request.post(
        "/upload_files_view/get_spreadsheet_uploaded_by_year/?format=json",
        data
    );

export const getSpreadsheetByMonth = (data = {}) =>
    request.post(
        "/upload_files_view/get_spreadsheet_by_month/?format=json",
        data
    );

export const deleteFileMonth = (idSpreadsheetFile = "") =>
    request.delete(
        `/upload_files_view/${idSpreadsheetFile}/delete_file_spreadsheet/?format=json`
    );

export const deleteTaxDocument = (data = {}) =>
    request.post(
        `/upload_files_view/delete_tax_document/?format=json`,
        data
    );

export const editTaxDocument = (data = {}) =>
    request.post(
        `/upload_files_view/edit_tax_document/?format=json`,
        data
    );
